export type Environment = 'dev' | 'stage' | 'preproduction' | 'production';

export interface FeatureConfig {
  dev: boolean;
  stage: boolean;
  preproduction: boolean;
  production: boolean;
  description?: string;
}

export const FEATURES = {
  // === PROJECT TABS ===
  ASSETS_TAB: {
    dev: true,
    stage: true,
    preproduction: false,
    production: false,
    description: "Вкладка Assets в проектах (в разработке)"
  },
  WARRANTIES_TAB: {
    dev: true,
    stage: true,
    preproduction: false,
    production: false,
    description: "Вкладка Warranties в проектах (в разработке)"
  },
  // === 3D VIEWS ===
  ROOM_3D_VIEW: {
    dev: true,
    stage: true,
    preproduction: false,
    production: false,
    description: "3D View для комнат (в разработке)"
  },
  // === UI COMPONENTS ===
  ORGANIZATION_DROPDOWN: {
    dev: false,
    stage: false,
    preproduction: false,
    production: false,
    description: "Выпадающий список организаций (пока не нужен)"
  },
  GLOBAL_SEARCH: {
    dev: true,
    stage: true,
    preproduction: false,
    production: false,
    description: "Глобальный поиск (скрыт в продакшене)"
  },
  RISK_LEVEL_FILTER: {
    dev: true,
    stage: true,
    preproduction: true,
    production: true,
    description: "Фильтр по уровню риска (доступен везде, но можно скрыть)"
  },
  // === LANDING PAGE ===
  NEW_LANDING_CONTENT: {
    dev: true,
    stage: false,
    preproduction: false,
    production: true,
    description: "Новый контент лендинга с фокусом на дата-центры (dev и production)"
  },
  // === TEAM ROLES ===
  SHOW_DEVELOPER_ROLES: {
    dev: true,
    stage: true,
    preproduction: true,
    production: false,
    description: "Показывать Developer роли в командах проектов"
  }
} as const;

export type FeatureName = keyof typeof FEATURES;

// Определяем текущую среду
export const getCurrentEnvironment = (): Environment => {
  if (typeof window === 'undefined') {
    return 'dev'; // SSR fallback
  }
  
  const hostname = window.location.hostname;
  
  if (hostname === 'app.finderz.ai' || hostname === 'finderz.ai' || hostname === 'www.finderz.ai') {
    return 'production';
  } else if (hostname === 'preprod.finderz.ai' || hostname.includes('preprod.finderz.ai')) {
    return 'preproduction';
  } else if (hostname.includes('stage.finderz.dev')) {
    return 'stage';
  } else {
    return 'dev';
  }
};
